<template>
  <div :class="['emd-form-group', `js${name}group`]">
    <label :class="['emd-label']">{{title}}</label>
    <input type="hidden" :name="name" @input="onInput">
    <div class="emd-section _separator" v-for="(val, key) in value" :key="key">
      <button type="button" class="emd-btn _color_danger"
        @click="deleteElement(name, key)"
        :disabled="value.length <= minItems">
          <i class="uil uil-minus"></i>
      </button>

      <div v-if="itemsType === 'simpleType'">
        <div v-for="(item, id) in items" :key="id">
          <p>simpleType</p>
        </div>
      </div>

      <div v-if="itemsType === 'complexType'">
        <div class="emd-chunk" v-for="(elem, index) in  Object.keys(items.properties)" :key="index">
          <emd-input-text v-if="items.properties[elem].type === 'string' && !items.properties[elem].hasOwnProperty('enum')"
            :name="elem"
            :title="items.properties[elem].title"
            :required="items.required.indexOf(elem) >= 0"
            :maxLength="items.properties[elem].maxLength"
            :minLength="items.properties[elem].minLength"
            :attrs="items.properties[elem].attrs"
            :onInput="onInput"
            :value="val[elem]"
            v-on:input="handleInput"
            v-model="val[elem]"
          />

          <emd-input-number v-if="items.properties[elem].type === 'number' || items.properties[elem].type === 'integer'"
            :name="elem"
            :title="items.properties[elem].title"
            :required="items.required.indexOf(elem) >= 0"
            :step="items.properties[elem].multipleOf"
            :max="items.properties[elem].maximum"
            :min="items.properties[elem].minimum"
            :attrs="items.properties[elem].attrs"
            :type="items.properties[elem].type"
            :onInput="onInput"
            :value="val[elem]"
            v-on:input="handleInput"
            v-model="val[elem]"
          />

          <emd-input-boolean v-if="items.properties[elem].type === 'boolean'"
            :name="elem"
            :title="items.properties[elem].title"
            :required="items.required.indexOf(elem) >= 0"
            :onInput="onInput"
            :value="val[elem] || items.properties[elem].default"
            v-on:input="handleInput"
            v-model="val[elem]"
          />

          <emd-select v-if="items.properties[elem].type === 'string' && items.properties[elem].hasOwnProperty('enum')"
            :name="elem"
            :title="items.properties[elem].title"
            :required="items.required.indexOf(elem) >= 0"
            :onInput="onInput"
            :enumList="items.properties[elem].enum"
            :value="val[elem] || items.properties[elem].default"
            v-on:input="handleInput"
            v-model="val[elem]"
          />
        </div>
      </div>
      <div v-if="itemsType === 'arrayType'">

        <div v-for="(item, id) in items" :key="id">
          <emd-input-text v-if="item.type === 'string' && !item.hasOwnProperty('enum')"
            :name="name+key"
            :title="item.title"
            :maxLength="item.maxLength"
            :minLength="item.minLength"
            :attrs="item.attrs"
            :onInput="onInput"
            :value="val[key]"
            v-on:input="handleInput"
            v-model="val[key]"
          />

          <emd-input-number v-if="item.type === 'number' || item.type === 'integer'"
            :name="name+key"
            :title="item.title"
            :step="item.multipleOf"
            :max="item.maximum"
            :min="item.minimum"
            :attrs="item.attrs"
            :onInput="onInput"
            :value="val[key]"
            v-on:input="handleInput"
            v-model="val[key]"
          />

          <emd-input-boolean v-if="item.type === 'boolean'"
            :name="prop+key"
            :title="item.title"
            :onInput="onInput"
            :value="val[key] || item.default"
            v-on:input="handleInput"
            v-model="val[key]"
          />

          <emd-select v-if="item.type === 'string' && item.hasOwnProperty('enum')"
            :name="prop+key"
            :title="item.title"
            :enumList="item.enum"
            :onInput="onInput"
            :value="val[key] || items.default"
            v-on:input="handleInput"
            v-model="val[key]"
          />

        </div>
      </div>
    </div>
    <div class="emd-chunk">
      <button
        v-if="!isListValidation"
        type="button"
        class="emd-btn _color_secondary"
        @click="addMoreElement(items.type)"
        :disabled="value.length >= maxItems">
          <i class="uil uil-plus"></i>
      </button>
    </div>
    <div :class="['emd-input-helper', `js${name}helper`]"></div>
  </div>
</template>
<script>
import EmdInputText from '@/components/project/Form/EmdInputText.vue'
import EmdInputNumber from '@/components/project/Form/EmdInputNumber.vue'
import EmdInputBoolean from '@/components/project/Form/EmdInputBoolean.vue'
import EmdSelect from '@/components/project/Form/EmdSelect.vue'

export default {
  name: 'EmdInputArray',
  components: {
    EmdInputText,
    EmdInputNumber,
    EmdInputBoolean,
    EmdSelect
  },
  computed: {
    itemsType: function () {
      if (!(this.items instanceof Object)) return false
      if (this.items instanceof Array) {
        return 'arrayType'
      } else {
        return this.items.type === 'object' ? 'complexType' : 'simpleType'
      }
    },
    isListValidation: function () {
      // verify if is an object because of tuple validation is an array type and there is no complexType
      return Array.isArray(this.items)
    }
  },
  props: {
    name: String,
    items: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    onInput: Function,
    title: String,
    minItems: {
      type: Number,
      default: 0
    },
    maxItems: {
      type: Number,
      default: 10
    }
  },
  methods: {
    addMoreElement (itemType) {
      let pushValue
      if (itemType === 'number' || itemType === 'integer') {
        pushValue = 0
      } else if (itemType === 'object') {
        pushValue = {}
      } else if (itemType === 'array') {
        pushValue = []
      } else if (itemType === 'boolean') {
        pushValue = true
      } else {
        pushValue = ''
      }
      this.value.push(pushValue)
    },
    deleteElement (element, index) {
      this.value.splice(index, 1)
    },
    handleInput (event) {
      this.$emit('input', this.value)
    }
  },
  mounted () {
    // Add default values to list validation
    if (!(Array.isArray(this.items))) {
      for (let i = 0; i < this.minItems; i++) {
        this.addMoreElement(this.items.type)
      }
    }
  }
}
</script>
